import * as helper from './../../../../../VX/View/Assets/Js/helper';
import * as Events from './Events';

export default class Buttons {
	constructor() {
		const buttons = helper.$('#buttons button');
		this.previousBtn = buttons[0];
		this.nextBtn = buttons[1];

		helper.addEventListener(this.previousBtn, 'click', function (evt) {
			evt.preventDefault();
			helper.triggerEvent(window,Events.PREVIOUS);
		});

		helper.addEventListener(this.nextBtn, 'click', function (evt) {
			evt.preventDefault();
			helper.triggerEvent(window,Events.NEXT);
		});

	}
}
